module.exports = __webpack_public_path__ + "static/media/what-we-offer.ae868a7c.png";